export default {
  button: "Verify",
  buttonHidden: "bank details",
  spinner: "Verifying",
  spinnerHidden: "bank details"
};
